import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";

const TenantAdminRoute = () => {
  const { isTenantAdmin } = useContext(AuthContext);
  return isTenantAdmin ? <Outlet /> : <Navigate to="/" replace />;
};

export default TenantAdminRoute;
